module.exports = __webpack_public_path__ + "static/media/step1desktop.dc12abd0.png";